export const userConstant = {
    GET_USER_REQUEST: "GET_USER_REQUEST",
    GET_USER_SUCCESS: "GET_USER_SUCCESS",
    GET_USER_FAILED: "GET_USER_FAILED",
    GET_USER_CLEAR: "GET_USER_CLEAR",
};
